import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Loading faction...")

import { useFactionsStore } from '@/store/factions';
import { computed, onMounted, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/store/users';
import { Tabs, Tab } from 'vue3-tabs-component';
import Home from '@/views/Factions/Home.vue';
import PreviousCards from './PreviousCards.vue';
import Statistics from './Statistics.vue';
import Members from './Members.vue';
import Settings from './Settings.vue';
import Spinner from '@/components/UI/Spinner.vue';
import { Rank } from '@/typings/user';
import FactionHeader from '@/components/Faction/FactionHeader.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const factionStore = useFactionsStore();
const userStore = useUserStore();
const route = useRoute();

const { faction } = toRefs(factionStore);
const { user } = toRefs(userStore);

const isFounder = computed(() => faction.value?.Admin === user.value?.Name);
const canAccessSettings = computed(
  () => isFounder.value || faction.value?.UserRank === Rank.admin
);

const isSingleScorecard = computed(() => !!faction.value?.FactionCards?.length);

function initialise() {
  factionStore.getFaction(route.params['factionId'].toString());
}
onMounted(initialise);

return (_ctx: any,_cache: any) => {
  return (_unref(faction))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(FactionHeader, {
          faction: _unref(faction),
          "single-view": _unref(isSingleScorecard),
          "founder-view": _unref(isFounder),
          onUpdated: initialise
        }, null, 8, ["faction", "single-view", "founder-view"]),
        _createVNode(_unref(Tabs), {
          options: { useUrlFragment: false },
          "nav-class": "flex w-full px-2 mb-2",
          "nav-item-class": "text-sm uppercase hover:text-primary",
          "nav-item-active-class": "border-b-2 border-primary text-primary",
          "nav-item-link-class": "block py-3 mr-3 sm:mr-8",
          "panels-wrapper-class": "px-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { name: "Home" }, {
              default: _withCtx(() => [
                _createVNode(Home, { faction: _unref(faction) }, null, 8, ["faction"])
              ]),
              _: 1
            }),
            (!_unref(isSingleScorecard))
              ? (_openBlock(), _createBlock(_unref(Tab), {
                  key: 0,
                  name: "Previous Cards"
                }, {
                  default: _withCtx(() => [
                    _createVNode(PreviousCards, { faction: _unref(faction) }, null, 8, ["faction"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(isSingleScorecard))
              ? (_openBlock(), _createBlock(_unref(Tab), {
                  key: 1,
                  name: "Statistics"
                }, {
                  default: _withCtx(() => [
                    (_unref(faction).MemberCount >= 3)
                      ? (_openBlock(), _createBlock(Statistics, {
                          key: 0,
                          faction: _unref(faction)
                        }, null, 8, ["faction"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_1, " Statistics can be unlocked with 5 or more faction members "))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Tab), {
              name: _unref(isSingleScorecard) ? 'Members' : 'Players'
            }, {
              default: _withCtx(() => [
                _createVNode(Members, {
                  rank: _unref(faction).UserRank
                }, null, 8, ["rank"])
              ]),
              _: 1
            }, 8, ["name"]),
            (_unref(canAccessSettings))
              ? (_openBlock(), _createBlock(_unref(Tab), {
                  key: 2,
                  name: "Settings"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Settings)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 64))
    : (_openBlock(), _createBlock(Spinner, { key: 1 }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }))
}
}

})